import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface TokenSet {
  accessToken: string;
  refreshToken: string;
  accessExpiresAt: string;
  refreshExpiresAt: string;
}

interface User {
  userId: string;
  email: string;
  displayName: string;
  role: 'admin' | 'manager';
  isActive: boolean;
  isTotpEnabled: boolean;
}

interface AuthState {
  accessToken: string | null;
  refreshToken: string | null;
  accessExpiresAt: string | null;
  refreshExpiresAt: string | null;
  user: User | null;
  setTokens: (t: TokenSet) => void;
  setUser: (u: User | null) => void;
  setLoggedIn: (tokens: TokenSet, user: Pick<User, 'userId' | 'email' | 'displayName' | 'role'>) => void;
  clearTokens: () => void;
  isAuthenticated: () => boolean;
  isAdmin: () => boolean;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      accessToken: null,
      refreshToken: null,
      accessExpiresAt: null,
      refreshExpiresAt: null,
      user: null,
      setTokens: (t) => set(t),
      setUser: (u) => set({ user: u }),
      setLoggedIn: (tokens, basicUser) => set({
        ...tokens,
        user: { ...basicUser, isActive: true, isTotpEnabled: false }
      }),
      clearTokens: () => set({ accessToken: null, refreshToken: null, accessExpiresAt: null, refreshExpiresAt: null, user: null }),
      isAuthenticated: () => !!get().accessToken,
      isAdmin: () => get().user?.role === 'admin'
    }),
    { name: 'codeshield-portal-auth', partialize: (s) => ({
      accessToken: s.accessToken, refreshToken: s.refreshToken,
      accessExpiresAt: s.accessExpiresAt, refreshExpiresAt: s.refreshExpiresAt, user: s.user
    }) }
  )
);
